module.exports = title => {
  // $lower = strtolower($string);
  // $pos = strpos($lower, 'i2i');
  // echo '<span class="d-none">' . $pos;
  // echo '</span>';
  // if ($pos && $pos > 0) {
  //   echo substr($lower, 0, $pos);
  //   echo '<span>i2i</span>';
  //   echo substr($lower, $pos + 3);
  // } else if ($pos === 0) {
  //   echo '<span>i2i</span>';
  //   echo substr($lower, 3);
  // } else {
  //   echo $string;
  // }

  const lower = title.toLowerCase();
  const pos = lower.indexOf('i2i');
  if (pos && pos > 0) {
    return `${lower.substring(0, pos)}<span>i2i</span>${lower.substring(pos + 3)}`;
  } else if (pos === 0) {
    return `<span>i2i</span>${lower.substring(3)}`;
  } else {
    return title;
  }
}
